import {
  CARAVAN_DETAILS_STEP,
  CARAVAN_INTRO_STEP,
  CARAVAN_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Caravan";

import { CaravanProductDetailsFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Caravan/ProductDetails/interfaces";
import { CaravanProductIntroFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Caravan/ProductIntro/interfaces";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { CaravanCoverage } from "Store/interfaces/products/coverage";
import { mapFormToInjuries } from "Store/priceCalculation/productMappers/common/injuriesMapper";
import { formBooleanToBoolean } from "Utils/formUtils";

export interface CaravanProductBackend {
  name: INSURANCE_NAME_VALUE;
  coverageGroup: CaravanCoverage;

  registrationYear: number;
  brand: string;
  model: string;

  coverageAmount: number;
  movables: number;
  permanentPlace: boolean;

  damageCountRecentYears: number;
  yearOfLastDamage?: number;
}

export const mapToCommerceCaravan = (
  data: Record<string, any>,
): CaravanProductBackend => {
  const caravanIntro: CaravanProductIntroFormValues =
    data.formData[CARAVAN_INTRO_STEP.id];
  const caravanDetails: CaravanProductDetailsFormValues =
    data.formData[CARAVAN_DETAILS_STEP.id];
  return {
    name: INSURANCE_NAME_VALUE.CARAVAN,
    coverageGroup: data.coverage,

    brand: caravanIntro.brand,
    model: caravanIntro.model,
    registrationYear: Number(caravanIntro.registrationYear),

    coverageAmount: caravanDetails.coverageAmount,
    permanentPlace: formBooleanToBoolean(caravanDetails.fixedPlace),
    ...mapFormToInjuries(caravanDetails.injuries, caravanDetails.injuryYear),

    movables: Number(data.formData[CARAVAN_PRICE_STEP.id].movables),
  };
};
